import { Injectable, OnDestroy, StateKey, TransferState, inject } from '@angular/core';

import { Observable, of, take, tap } from 'rxjs';

import { finShare } from '@fcom/rx';

@Injectable()
export class StateTransferService implements OnDestroy {
  private state = inject(TransferState);

  private requested: Map<StateKey<unknown>, Observable<unknown>>;

  constructor() {
    this.requested = new Map<StateKey<unknown>, Observable<unknown>>();
  }

  ngOnDestroy(): void {
    this.requested.clear();
  }

  wrapToStateCache<T>(stateKey: StateKey<T>, getter: () => Observable<T>): Observable<T> {
    if (this.state.hasKey<T>(stateKey)) {
      this.requested.delete(stateKey);
      return of(this.state.get<T>(stateKey, null));
    }
    if (this.requested.has(stateKey)) {
      return this.requested.get(stateKey) as Observable<T>;
    }
    const ret$ = getter().pipe(
      take(1),
      tap((val) => this.state.set<T>(stateKey, val)),
      finShare({ bufferSize: 1, refCount: false })
    );
    this.requested.set(stateKey, ret$ as Observable<unknown>);
    return ret$;
  }
}
